import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import './index.scss';
import CloAnalytics from '$/pages/client/clo-analytics/CloAnalytics';
import CloDealAnalytics from '$/pages/client/clo-analytics/CloDealAnalytics';
import { getTreppCLOEnabled } from '$/store/release-feature-flags/selectors';

interface ICloAnalyticsRootProps {
  isTreppCLOEnabled: boolean;
}

const CloAnalyticsRoot: React.FC<ICloAnalyticsRootProps> = props => {
  const { isTreppCLOEnabled } = props;

  if (isTreppCLOEnabled) {
    return <CloDealAnalytics />;
  }

  return <CloAnalytics />;
};

const mapStateToProps = (state: AppState) => {
  const { isTreppCLOEnabled } = getTreppCLOEnabled(state);

  return {
    isTreppCLOEnabled,
  };
};

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CloAnalyticsRoot);
